import React, {useEffect} from "react"
import styled from "styled-components"
import ChannelEpg from "./ChannelEpg"
import "../../other/Transition.css"
import {getImageUrl} from "../../other/axios"

const Li = styled.li`
vertical-align: middle;
display: inline-flex;
justify-content: center;
align-items: center;
color: #829196;
width: 90% !important;
left: 5% !important;
border-bottom: #000 1px solid;

&:focus, &:hover{
    outline-width: 0px;
    cursor: pointer;
    border-bottom: #000 0px solid !important;
}

& + & {
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
}
`

const ChannelNumber = styled.div`
align-self: center;
text-align: left;
padding: 0;
padding-left: 1rem;
& > div{ font-size: 1rem !important; }
`
const HeaderChannel = styled.div`
padding-bottom: .4rem!important;
line-height: 1!important;
font-size: 1rem;
font-weight: 700;
`
const Logo = styled.div`
padding: .1rem .1rem;
border-radius: .2rem;
text-align: center;
width: 100%;
font-weight: bold;
min-height: 3rem;
max-height: 3rem;
background-position-x: center;
background-position-y: center;
background-size: contain;
background-repeat: no-repeat;
`

const ChannelContainer = styled.div`
`

const Channel = ({ Name, Image, Epg, Shift, Number, id, selected, selectEvent, virtualScrollStyle }) => {
    useEffect(()=>{       
        if(selected){
            setTimeout(() => {
                document.getElementById("selectedCh") && (document.getElementById("selectedCh").className += " hvr-shutter-in-horizontal-on")
            }, 100)
        }
    },[selected])    

    return (
        <Li tabIndex={-1} onClick={!selected ? selectEvent : undefined} style={virtualScrollStyle} id={selected ? "selectedCh" : ""} className={selected ? "channel hvr-grow-shadow  hvr-shutter-in-horizontal" : "channel hvr-reveal hvr-grow-shadow"}> 
            <ChannelContainer className="container">
                <div className="row">
                    <ChannelNumber className="col-sm-1 order-1">
                        <HeaderChannel>
                            <span>{Number}</span>
                        </HeaderChannel>
                    </ChannelNumber>
                    <div className="col-md-2 col-sm-3 order-2">
                        <Logo style={{backgroundImage:`url(${getImageUrl(Image)})`}}>
                        </Logo>
                    </div>
                    <ChannelEpg Name={Name} Epg={Epg} Shift={Shift} chId={id} isPlaying={selected}/>
                </div>
            </ChannelContainer>
        </Li>
    )
}

export default Channel
